'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCustom = undefined;

var _IconCustom = require('./IconCustom');

exports.IconCustom = _IconCustom.IconCustom;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-icons/dist/IconCustom/index.js
// module id = 709
// module chunks = 0